import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { Navigate, useNavigate } from "react-router-dom";
import axios from "axios";
import { useState, useEffect } from "react";
import CustomToaster from "../../../../Ui/toaster/CustomToaster";
import FormHelperText from "@mui/material/FormHelperText";
import Cookies from "universal-cookie";
import CloseIcon from "@mui/icons-material/Close";
import { Logger } from "../../../../Logger/Logger";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  height: 350,
  border: 0,
  bgcolor: "background.paper",
  borderRadius: 6,
  boxShadow: 24,
  p: 4,
};
export const AssignModal = ({ modalData, setOpen, open }) => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const [admins, setAdmins] = useState([]);
  const [disable, setDisable] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [age, setAge] = useState("");
  const navigate = useNavigate();
  const id = modalData.id;
  const [toaster, setToaster] = useState(false);
  const [title, setTitle] = useState("");
  const [subTitle, setSubTitle] = useState("");
  const [variant, setVariant] = useState("");
  const [error, setError] = useState(null);
  const [name, setName] = useState("");
  const [nameId, setNameId] = useState("");

  const [formData, setFormData] = useState({
    assigned_to: "",
  });

  const cookies = new Cookies();
  const apiKey = cookies.get("UserLogin");

  const getAdminsList = () => {
    axios
      .get(`${BASE_URL}api/user/admins`, {
        headers: { Authorization: `Bearer ${apiKey}` },
      })
      .then((res) => {
        Logger.debug("in admins api", res);
        setAdmins(res.data.data);
      })
      .catch((error) => {
        Logger.error("Error in admins api ", error);
        if (error.response.status == 403) {
          cookies.remove("UserLogin");
          cookies.remove("UserDetails");
          cookies.remove("adminRole");
          cookies.remove("sysAdminRole");
          cookies.remove("createdBy");
          cookies.remove("UserLoginAccessToken");
          cookies.remove("UserName");
          navigate("/");
        }
        if (error.response.status == 404) {
          navigate("/*");
          setTimeout(() => {
            navigate("/secured/empDashboard");
          }, 5000);
        }
      });
  };

  useEffect(() => {
    getAdminsList();
  }, [open, modalData]);

  const handleChange = (event) => {
    setFormData({
      ...FormData,
      assigned_to: event.target.value,
    });
    setNameId(event.target.value);
    setError(null);
    Logger.debug("selected value", event.target);
  };

  const handleClick = () => {
    setDisable(true)
    if (formData.assigned_to !== "") {
      axios
        .patch(`${BASE_URL}api/ticket/assign_ticket/${id}/`, formData, {
          headers: { Authorization: `Bearer ${apiKey}` },
        })
        .then((res) => {
          Logger.debug("response in assign ticket api", res);
          setToaster(true);
          setTitle("Success");
          setDisable(false)
          setSubTitle(
            `Ticket No: ${id} assigned to ${admins.map((e) => {
              if (e.id == nameId) {
                return e.name
              }
            })}`
          );
          setVariant("success");
          setTimeout(() => {
            setToaster(false);
            setOpen(false);
          }, 1000);
        })
        .catch((error) => {
          Logger.error("in error of ticket api", error);
          if (error.response.status == 403) {
            cookies.remove("UserLogin");
            cookies.remove("UserDetails");
            cookies.remove("adminRole");
            cookies.remove("sysAdminRole");
            cookies.remove("createdBy");
            cookies.remove("UserLoginAccessToken");
            cookies.remove("UserName");
            navigate("/");
            setTimeout(() => {
              navigate("/");
            }, 2000);
          }
          if (error.response.status == 404) {
            navigate("/*");
            setTimeout(() => {
              navigate("/secured/empDashboard");
            }, 5000);
          }
        });
    } else {
      setError("Please Select an Option");
    }
  };
  return (
    <div className="ml-[250px] mt-[100px]">
      {!toaster && (
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={open}
          onClose={handleClose}
          // closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={open}>
            <Box sx={style}>
              <CloseIcon className="ml-[90%] cursor-pointer" onClick={() => setOpen(false)} />
              <Box sx={{ minWidth: 120 }}>
                <div>
                  <h1 className="mb-[20px] text-center text-xl">
                    Assign Ticket
                  </h1>
                </div>

                <p className="mb-2">Ticket No: {modalData.id}</p>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Assign Ticket To
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={formData.assigned_to}
                    name={name}
                    label="Assign Ticket To"
                    onChange={handleChange}
                  >
                    <MenuItem value="">Select an option</MenuItem>
                    {admins &&
                      admins.map((e) => {
                        return (
                          <MenuItem key={e.id} value={e.id} name={e.name}>
                            {e.name}
                          </MenuItem>
                        );
                      })}
                  </Select>
                  {setFormData.assigned_to == null ? (
                    <FormHelperText sx={{ color: "red" }}>
                      {error}
                    </FormHelperText>
                  ) : (
                    <></>
                  )}
                </FormControl>
              </Box>
              <Button
                disabled={disable}
                variant="contained"
                className="!bg-[#05374F]"
                sx={{ position: "absolute", bottom: 20, right: 20 }}
                onClick={handleClick}
              >
                Assign
              </Button>
            </Box>
          </Fade>
        </Modal>
      )}
      {toaster ? (
        <CustomToaster
          title={title}
          subTitle={subTitle}
          variant={variant}
        ></CustomToaster>
      ) : (
        <></>
      )}
    </div>
  );
};
